import Joi from 'joi';

export const listNameSchema = Joi.string().required().min(2).max(100).messages({
  'any.required': 'List Name is required',
  'string.min': 'Please be more descriptive',
  'string.max': 'Please reduce length of list name',
  'string.base': 'List name has to be a string',
});

export const listCreatedTypeSchema = Joi.required()
  .valid('default', 'csv', 'discovery', 'demographics', 'inbound', 'list', 'rvBoard')
  .messages({
    'any.required': 'List Created Type is Required Field',
    'any.only': 'This value is not allowed in List Created Type Field',
    'string.base': 'List Created Type has to be a string',
  });

export const createListSchema = Joi.object({
  name: listNameSchema,
  listCreatedType: listCreatedTypeSchema,
});
